<div *ngIf='isVisible' class='warningBanner envBanner borderedSpanBanner'>
  Careful now — you're looking at:
  <span class='bg-light border border-dark px-3'>{{ env }}</span>
</div>
